module.exports = __webpack_public_path__ + "cda22cc1bdab305eb7a71a286691e1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cTable.png
// module id = 491
// module chunks = 0